<footer class="">
  <div class="container mx-auto ps-4 border-l border-l-gray-300  section-top-pad section-bottom-pad footer-xt-space">

  </div>
  <div class="footer-bg-wrapper pt-4">
    <div class="container mx-auto ">
      <div class="footer-content-wrapper">
        <div class="grid lg:grid-cols-3 gap-10 text-white">
          <div>
            <a href="#">
              <img src="assets/images/umbrella-logo-light.svg" alt="umbrella light logo">
            </a>

            <p class="mt-5">Umbrella Travel delivers tailored corporate travel solutions, ensuring
              efficiency and exceptional service for businesses.</p>
          </div>
          <div>
            <ul class="space-y-3">
              <li>
                <h2 class="text-xl font-semibold text-orange-500 ">Links</h2>
              </li>
              <li>
                <a href="javascript:void(0)" onclick="window.location.href='services'" class="hover:text-orange-200 transition">Our Services</a>
              </li>
              <li>
                <a href="javascript:void(0)" onclick="window.location.href='about-us'"  class="hover:text-orange-200 transition">About us</a>
              </li>
              <li>
                <a href="javascript:void(0)"  class="hover:text-orange-200 transition">News & Updates</a>
              </li>
              <li>
                <a href="javascript:void(0)" onclick="window.location.href='contact-us'" class="hover:text-orange-200 transition">Contact us</a>
              </li>

            </ul>
          </div>
          <div>
            <ul class="space-y-3">
              <li>
                <h2 class="text-xl font-semibold text-orange-500">Contact us</h2>
              </li>
              <li>
                <a href="mailTo:info&#64;umbrellatravel.com"
                   class=" email-id-top font-normal flex items-center hover:text-orange-200 transition">
                  <span class="icon-envelope me-2"></span> info&#64;umbrellatravel.com
                </a>
              </li>
              <li>
                <a href="tel:917984949224"
                   class=" flex items-center phone-number-top font-normal hover:text-orange-200 transition">
                  <span class="icon-phone me-2"></span> +27-(83) 200-4179
                </a>
              </li>

            </ul>
            <div class="mt-7">
              <h2 class="text-xl font-semibold text-orange-500">Follow us</h2>
              <ul class="space-x-3 flex items-center mt-5">

                <li>
                  <a href="#"><span
                    class="icon-linkedin text-3xl text-gray-400 hover:text-white transition"></span></a>
                </li>
                <li>
                  <a href="#"><span
                    class="icon-facebook-square text-3xl text-gray-400 hover:text-white transition"></span></a>
                </li>
                <li>
                  <a href="#"><span
                    class="icon-instagram text-3xl text-gray-400 hover:text-white transition"></span></a>
                </li>
                <li>
                  <a href="#"><span
                    class="icon-x-twitter text-3xl text-gray-400 hover:text-white transition"></span></a>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div class="flex flex-col sm:flex-row items-center justify-center text-white text-sm py-4 border-t border-t-gray-200/10">
        <a href="#" class="hover:text-orange-500 transition">Sitemap</a> <span
        class="mx-3 hidden sm:block">|</span> <a href="#"
                                                 class="hover:text-orange-500 transition sm:my-0 my-3">Privacy Policy</a> <span
        class="mx-3 hidden sm:block">|</span> All Rights Reserved © Team 2023
      </div>
    </div>
  </div>
</footer>
<span class="text-orange-500 text-xs font-semibold backTop cursor-pointer">Back to top</span>
